



















import { defineComponent } from "@vue/composition-api";

export default defineComponent({
    name: "LoadingDialog",
    props: {
        message: { type: String, default: "LOADING ..." },
        value: { type: Boolean, default: false }
    }
});
